export const validator = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$/;

const password = {
  validator,
};

export default password;
